import styled from 'styled-components';
import { Text } from '../../UI/Text';

export const NameText = styled(Text)`
    font-size: 20px;
    opacity: 0.8;
    font-weight: bold;
    text-align: center;
`;

export const CircleMiddle = styled.div`
    width: 100%;
    height: 33%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CircleTop = styled.div`
    width: 100%;
    height: 33%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
`;

export const CircleBottom = styled.div`
    width: 100%;
    height: 33%;
    display: flex;
    justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/GymTvCircle/style.js